import { Theme } from '@libs/types';

const getFontSrc = (urls: string[]) => {
    let urlsStr = '';
    if (urls && urls.length > 0) {
        urls.forEach((url, index, arr) => {
            if (url) {
                const match = url.match(/(?<=\.)\w+$/);
                if (!match) return;
                const format = match[0];
                const separator = index === arr.length - 1 ? ';' : ',';
                urlsStr += `url(${url}) format('${format}')${separator}\n`;
            }
        });
    }
    return urlsStr;
};

export const getThemeFonts = (customTheme?: Theme) => {
    if (customTheme?.typography?.fonts && typeof customTheme?.typography?.fonts === 'object' && !Array.isArray(customTheme?.typography?.fonts)) {
        const result = [''];
        for (const value of Object.values(customTheme.typography.fonts)) {
            let newString = '';
            for (const font of Object.values(value)) {
                const fontFamily = font?.fontFamily ? `font-family: ${font?.fontFamily}` : '';
                const fontWeight = font?.fontWeight ? `font-weight: ${font?.fontWeight}` : '';
                const src = font?.source && Array.isArray(font.source) && font?.source.length > 0 ? `src: ${getFontSrc(font.source)}` : '';
                newString += `@font-face {
                    ${fontFamily};
                    ${fontWeight};
                    ${src}
                }\n`;
            }
            result.push(newString);
        }
        return result.join('');
    }
    return '';
};
